import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { selectReceiversGroups } from '@core-app/state/alerting';
import * as AlertingActions from '@core-app/state/alerting/alerting.actions';
import { Store } from '@ngrx/store';

@Component({
  selector:
    'frontend-workspace-daily-production-target-missed-general-config-modal',
  templateUrl:
    './daily-production-target-missed-general-config-modal.component.html',
  styleUrl:
    './daily-production-target-missed-general-config-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DailyProductionTargetMissedGeneralConfigModalComponent implements OnInit {
  private readonly _store = inject(Store);

  recipientGroups$ = this._store.select(selectReceiversGroups());

  formGroup = new FormGroup({
    approversGroupId: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {
    this._store.dispatch(AlertingActions.fetchReceiversGroup());
  }

  submit() {
    if (!this.formGroup.valid) {
      return;
    }
  }
}
